// extracted by mini-css-extract-plugin
module.exports = {"bodyContainer":"Body_bodyContainer__49FNL","contentWrapper":"Body_contentWrapper__1Suci"};